import './ux-signals.scss';

export const UxSignals = ({ id, demo }) => {

    return (

        <div
            data-uxsignals-embed={id}
            data-uxsignals-mode={demo ? 'demo' : ''}>
            </div>

    )
}
